module.exports = __webpack_public_path__ + "static/homepagePlaceholder-7028367fddec9d1633d9fdfe56b0e39a.png";